import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AuthAppService} from "sign-up-app/services/auth.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { COUNTRY_LANGUAGE_MAP } from 'main_app/enums/country-language';

@Component({
    selector: 'forgotten-password',
    templateUrl: './forgotten-password.component.html',
    styleUrls: ['./forgotten-password.component.less']
})
export class ForgottenPasswordComponent implements OnInit {

    @ViewChild('emailInput')
    private emailInput!: ElementRef<HTMLInputElement>;

    @ViewChild('emailWrongMsg')
    private emailWrongMsg!: ElementRef<HTMLDivElement>;

    fullLiveUrl = window.fullLiveUrl;
    email: string = '';
    isEmailValid: boolean = false;
    forgottenPassState: string = 'completeEmail';
    topMargin: number = 130;

    resetFormButtonText = $localize`SEND_ME_A_PASSWORD_RESET_FORM`;
    constructor(
        private router: Router,
        private authService: AuthAppService,
        private el: ElementRef,
        private translate: TranslateService,
        private http: HttpClient
    ) {

    }

    ngOnInit(): void {
        const savedLang = localStorage.getItem('language');
        if (savedLang) {
            this.setLanguage(savedLang);
        } else {
            this.detectLanguageByIP();
        }
    }

    setLanguage(lang: string): void {
        this.translate.setDefaultLang(lang);
        this.translate.use(lang);
        localStorage.setItem('language', lang);
    }

    detectLanguageByIP(): void {
        this.http.get<any>('https://ipwho.is/', {
            headers: new HttpHeaders({ 'skipInterceptor': 'true' })
        }).subscribe({
            next: (response) => {
                const selectedLang = COUNTRY_LANGUAGE_MAP[response.country_code] ? COUNTRY_LANGUAGE_MAP[response.country_code] : 'en';
                this.setLanguage(selectedLang);
            },
            error: () => {
                this.setLanguage('en');
            }
        });
    }

    goToSignIn(): void {
        window.location.href = this.fullLiveUrl+'sign-in';
        //this.router.navigate(['signIn'], { replaceUrl: true });
    }

    validateEmail(): void {
        this.translate.get(['THE_EMAIL_ADDRESS_FIELD', 'NOT_A_VALID_EMAIL']).subscribe((translations) => {
            this.isEmailValid = this.authService.ValidateField(this.emailInput, this.emailWrongMsg, this.email, ['required', 'email'],
                { 'required': translations['THE_EMAIL_ADDRESS_FIELD'], 'email': translations['NOT_A_VALID_EMAIL'] });
        });
    }

    sendLetter(): void {

        this.validateEmail();

        if (this.isEmailValid) {

            const data = JSON.stringify({ 'email': this.email.toLowerCase() });

            this.authService.SendPasswordReset(data).then((res: string) => {
                let data = JSON.parse(res.toString());
                if (data.success) {
                    this.forgottenPassState = 'emailSent';
                    this.topMargin = 55;
                }
            });
        }
    }

}
